import { Box, Button, InputBase, Modal, Typography, Input, IconButton, Tooltip, Select, MenuItem, getListSubheaderUtilityClass, Stack, TextField, Tabs, Tab } from "@mui/material";
import { BonusProducts } from './bonus_products';
import { useDispatch, useSelector } from "react-redux";
import { MultiSelect } from 'primereact/multiselect';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Toast } from 'primereact/toast';
import { useEffect, useRef, useState } from "react";
import SearchIcon from '@mui/icons-material/Search';
import { OffersTable } from "../../sub_components/offers_table";
import { useGetOffers } from "../globalFunctions";
import { updateOfferDetail, updateOfferEdit, updateOfferModal, updateOfferSearch } from "../../Redux/offers";
import CircularProgress from '@mui/material/CircularProgress';
import { Dropdown } from 'primereact/dropdown';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import CustomAxios from "../../utils/CustomAxios";
import dayjs from "dayjs";

export function OfferManagement() {
    const dispatch = useDispatch()
    const toast = useRef(null);
    const getOffers = useGetOffers()
    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState({});
    const edit = useSelector(state => state.offers.offerEdit)
    const modal = useSelector(state => state.offers.offerModal)
    const [loading, setLoading] = useState(false)
    // "offers" or "loyalty": loyalty products (offers bought with points) have
    // their own tab.
    // ?tab=bonus opens Bonus Products directly (e.g. a link to its banner switch).
    const [offerTab, setOfferTab] = useState(() =>
        new URLSearchParams(window.location.search).get("tab") === "bonus" ? "bonus" : "offers"
    )
    const loyaltyTab = offerTab === "loyalty"
    const products = useSelector(state => state.products.products)
    const offerDetails = useSelector(state => state.offers.offerDetails)
    const user_id = useSelector(state => state.user.id)
    const inventory = useSelector(state => state.inventory.inventory)
    const selectedHub = useSelector(state => state.user.selected_hub); // gets ID
    const user_role = localStorage.getItem('role');
    
    // Get assigned hubs for role-based filtering
    const assignedHubs = JSON.parse(localStorage.getItem('hub') || '[]');
    
    // Build inventory options: show all, but disable unassigned for restricted roles
    const filteredInventory = (inventory || []).map((inv) => {
        const isAssigned = assignedHubs.includes(inv.value);
        return {
            ...inv,
            name: inv.name ?? 'Not assigned hub',
            disabled: ['admin', 'supervisor', 'customer_engagement_admin'].includes(user_role) ? !isAssigned : false
        };
    });
    
    // Check if user can manage offers (create, edit, delete)
    const canManageOffers = ['super_admin', 'admin', 'supervisor'].includes(user_role);

    console.log(products)
    useEffect(() => {
        getOffers()
    }, [])
    useEffect(() => {
        if (offerDetails) {
            console.log(offerDetails);
    
            const updatedOfferDetails = {
                ...offerDetails,
                start_date: offerDetails.start_date ? dayjs(offerDetails.start_date) : null,
                end_date: offerDetails.end_date ? dayjs(offerDetails.end_date) : null,
                offer_products: offerDetails.offer_products?offerDetails.offer_products.id : null
            };
    
            setFormData(updatedOfferDetails);
        }
    }, [offerDetails]);
    const handleOpen = () => {
        setErrors({})
        dispatch(updateOfferDetail({
            offer_name: '',
            offer_description: '',
            offer_products: '',
            total_quantity: '',
            available_quantity: '',
            is_active: false,
            start_date: null,
            end_date: null,
            inventory_list:user_role==="supervisor"?selectedHub:formData.inventory_list,
            ...(loyaltyTab ? { offer_type: 'loyalty offer', min_spent: '' } : {}),
        }));
        dispatch(updateOfferEdit(false));
        dispatch(updateOfferModal(true))
    };

    const handleClose = () => {
        setErrors({})
        dispatch(updateOfferModal(false));
        dispatch(updateOfferEdit(false))
        dispatch(updateOfferDetail({
            offer_name: '',
            offer_description: '',
            offer_products: '',
            total_quantity: '',
            available_quantity: '',
            inventory_list:[],
            is_active: false,
            start_date: null,
            end_date: null,
        }));
    };
    const handleChange = (e, date = null) => {
        console.log(e);
        if (e.name === "offer_products") {
            const { name, value } = e.target || {};
            return { ...formData, "offer_products": value };
          }
        if (date === "start_date" || date === "end_date") {
            setFormData((prevData) => ({
                ...prevData,
                [date]: e
            }));
            return;
        }
    
        const { name, value } = e.target;
        
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };
    const availability = [
        { name: 'Active', value: true },
        { name: 'Inactive', value: false },
    ];
    const offer_type = [
        { name: 'bogo', value: 'bogo' },
        { name: 'one time offer', value: 'one time offer' },
        { name: 'multi time offer', value: 'multi time offer' },
        { name: 'loyalty offer', value: 'loyalty offer' },
    ];
    
    // A loyalty offer has no price here: its points are set on the Free
    // Product rule that maps it in Loyalty Configuration.
    const loyaltyOfferError = () => null;
    // The server's own reason, naming the field, instead of a generic
    // "Missing Required Fields" that hides which one is wrong.
    const serverErrorText = (err, fallback) => {
        const data = err?.response?.data || {};
        const errors = data.errors || {};
        const labels = { min_spent: "Points / Minimum Spent", offer_products: "Offer Product", inventory_list: "Hubs", total_quantity: "Total Quantity", available_quantity: "Available Quantity", offer_description: "Description", offer_name: "Name", offer_type: "Offer Type", start_date: "Start Date", end_date: "End Date", is_active: "Availability" };
        const key = Object.keys(errors)[0];
        if (key) {
            const message = Array.isArray(errors[key]) ? errors[key][0] : String(errors[key]);
            return key === "non_field_errors" ? message : `${labels[key] || key}: ${message}`;
        }
        return data.error || data.message || fallback;
    };

      const handleSaveOffer = async () => {
            const loyaltyError = loyaltyOfferError();
            if (loyaltyError) {
                toast.current.show({ severity: 'error', summary: 'Error', detail: loyaltyError, life: 3000 });
                return;
            }
            try{
                formData.user=user_id
                // await validationSchema.validate(formData, { abortEarly: false });
                // setErrors({});
                    setLoading(true);
                    const response = await CustomAxios.post(`create_offer/`, formData, {
                    }).then(res => {
                        toast.current.show({ severity: 'success', summary: 'Success', detail: 'Product Added Successfully', life: 3000 });
                        getOffers()
                        handleClose()
                        setFormData({})
                        dispatch(updateOfferModal(false))
                        setLoading(false);
                    }).catch((err)=>{
                        console.log(err.response.data.errors);
                        toast.current.show({ severity: 'error', summary: 'Error', detail: serverErrorText(err, 'Missing Required Fields'), life: 3000 });
                        setLoading(false);
                      });
            }
            catch (validationErrors) {
                // if (validationErrors.name === "ValidationError") {
                //   const formErrors = {};
                //   validationErrors.inner.forEach((error) => {
                //     formErrors[error.path] = error.message;
                //   });
                  setErrors(validationErrors);
                  setLoading(false);
              }
        }
        const handleUpdateOffer = async (id) => {
            const loyaltyError = loyaltyOfferError();
            if (loyaltyError) {
                toast.current.show({ severity: 'error', summary: 'Error', detail: loyaltyError, life: 3000 });
                return;
            }
            try{
                formData.user=user_id
                setLoading(true);
                // await validationSchema.validate(formData, { abortEarly: false });
                // setErrors({});
            const response = await CustomAxios.put(`offers/update/${id}/`, formData, {
            }).then(res => {
                toast.current.show({ severity: 'success', summary: 'Success', detail: 'Product updates Successfully', life: 3000 });
                getOffers()
                handleClose()
                setFormData({})
                dispatch(updateOfferModal(false))
                setLoading(false)
            }).catch((err) => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: serverErrorText(err, 'Update failed'), life: 3000 });
                setLoading(false);
            })}
            catch (validationErrors) {
                // if (validationErrors.name === "ValidationError") {
                //   const formErrors = {};
                //   validationErrors.inner.forEach((error) => {
                //     formErrors[error.path] = error.message;
                //   });
                  setErrors(validationErrors);
                  setLoading(false);
              }
        }


        const selectedCountryTemplate = (option, props) => {
            if (option) {
                return (
                    <Box sx={{ display: "flex", gap: "10px" }}>
                        <Box component="img" alt={option.name} src={option.image} sx={{ width: '16px', height: "16px", objectFit: "cover" }} />
                        <Box>{option.name}</Box>
                    </Box>
                );
            }
    
            return <span>{props.placeholder}</span>;
        };
    
        const countryOptionTemplate = (option) => {
            return (
                <Box sx={{ display: "flex", gap: "10px" }}>
                    <Box component="img" alt={option.name} src={option.image} sx={{ width: '30px', height: "30px", objectFit: "cover" }} />
                    <Box>{option.name}</Box>
                </Box>
            );
        };
        console.log(formData)
    
    // Check if user can manage offers - AFTER all hooks
    if (!canManageOffers) {
        return (
            <Box sx={{ display: "flex", flexDirection: "column", gap: "20px", padding: "20px" }}>
                <Typography variant="h6" color="error">
                    Access Denied
                </Typography>
                <Typography>
                    You don't have permission to manage offers. You can only send push notifications.
                </Typography>
            </Box>
        );
    }
    
    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: "20px", width: "100%", padding: "30px" }}>
            <Toast ref={toast} />
            <ToastContainer position="top-right" autoClose={1000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="light" transition="Bounce" />
            <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                <Box sx={{ display: "flex", flexDirection: "column", gap: "8px", marginBottom: "20px" }}>
                    <Typography sx={{ fontSize: "16px", fontWeight: "700", lineHeight: "24px" }}>Offer Management</Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: "500", lineHeight: "22px" }}>Offer Details</Typography>
                </Box>
                {offerTab !== "bonus" ? (
                <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%", marginBottom: "30px" }}>
                    <Box sx={{ position: "relative" }}>
                        <InputBase sx={{ backgroundColor: "white", height: "32px", width: "100%", maxWidth: "268px", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px 5px 40px", fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} onChange={(e) => dispatch(updateOfferSearch(e.target.value))} placeholder="Search item name" />
                        <SearchIcon sx={{ position: "absolute", left: "12px", top: "5px", width: "20px", height: "20px" }} />
                    </Box>
                    <Button variant="contained" sx={{ textTransform: "none" }} onClick={() => handleOpen()}> {loyaltyTab ? "Add Loyalty Product" : "Add Offer"}</Button>
                </Box>
                ) : null}
                <Tabs value={offerTab} onChange={(e, value) => setOfferTab(value)} sx={{ marginBottom: "16px", borderBottom: 1, borderColor: "divider" }}>
                    <Tab value="offers" label="Offers" sx={{ textTransform: "none" }} />
                    <Tab value="loyalty" label="Loyalty Products" sx={{ textTransform: "none" }} />
                    <Tab value="bonus" label="Bonus Products" sx={{ textTransform: "none" }} />
                </Tabs>
                {loyaltyTab ? (
                    <Typography sx={{ fontSize: "13px", color: "text.secondary", marginBottom: "12px" }}>
                        Products customers can buy with loyalty points. Set each one's points in Loyalty Configuration → Redemption Rules → Free Product. Available Units is how many are left to buy.
                    </Typography>
                ) : null}
                {offerTab === "bonus" ? <BonusProducts /> : <OffersTable view={loyaltyTab ? "loyalty" : "all"} />}

                <Modal
                    open={modal}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    sx={{ zIndex: 1000 }}
                >
                    <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '100%', maxWidth: "900px", height: "500px", backgroundColor: 'white', }}>
                        <Box sx={{ height: "46px important", padding: "12px 24px", backgroundColor: "#EEEEEE", display: "flex", alignItems: "center" }}>
                            <Typography sx={{ fontSize: "14", fontWeight: "500", lineHeight: "22px" }}> {formData.offer_type === "loyalty offer" ? (edit ? "Edit Loyalty Product" : "Add Loyalty Product") : (edit ? "Edit Offer" : "Add Offer")}</Typography>
                        </Box>
                        <Box >
                            <Box sx={{ padding: "24px", display: "flex", gap: "16px", flexDirection: "column", height: "400px", overflowY: "auto" }}>
                                <Box sx={{ width: "100%", display: "flex", flexDirection: "row", gap: "10px" }}>
                                    <Box sx={{ width: "50%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                        <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }} >Offer Type<span style={{ color: "red", marginLeft: "5px" }}>*</span></Typography>
                                        <Dropdown onChange={(e)=>handleChange(e)} value={formData.offer_type} options={offer_type} name="offer_type" optionLabel="name" style={{ zIndex: "1000" ,height:"32px"}}
                                                placeholder="Select Offer Type" className="w-full md:w-14rem"
                                                filter filterBy="name" optionDisabled={(option) => option.name === "discount"}
                                            />
                                        </Box>
                                    <Box sx={{ width: "50%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                        <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Name<span style={{ color: "red", marginLeft: "5px" }}>*</span></Typography>
                                        <InputBase value={formData.offer_name} sx={{ backgroundColor: "white", width: "100%", height: "32px", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px", fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} placeholder="Enter Offer name" name="offer_name" onChange={handleChange} />
                                    </Box>
                                    <Box sx={{ width: "50%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                        <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }} >Offer Product</Typography>
                                        <Dropdown onChange={(e)=>handleChange(e)} value={formData.offer_products} options={products} name="offer_products" optionLabel="name" style={{ zIndex: "1000" ,height:"32px"}}
                                                placeholder="Select Product" className="w-full md:w-14rem"
                                                valueTemplate={selectedCountryTemplate} itemTemplate={countryOptionTemplate}
                                                filter filterBy="name"
                                            />
                                        </Box>
                                    {formData.offer_type==="bogo"&&<Box sx={{ width: "50%",display: "flex", flexDirection: "column", gap: "10px" }}>
                                        <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }} >Mapped Products</Typography>
                                        <MultiSelect onChange={(e)=>handleChange(e)} value={formData.mapped_product} options={products} name="mapped_product" optionLabel="name" style={{ zIndex: "1000" ,height:"32px"}}
                                                placeholder="Select Products" className="w-full md:w-14rem"
                                                valueTemplate={selectedCountryTemplate} itemTemplate={countryOptionTemplate}
                                                filter filterBy="name"
                                            />
                                        </Box>}
                                </Box>
                                <Box sx={{ width: "100%", display: "flex", flexDirection: "row", gap: "10px" }}>
                                    <Box sx={{ width: "50%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                        <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Description<span style={{ color: "red", marginLeft: "5px" }}>*</span></Typography>
                                        <InputBase value={formData.offer_description} sx={{ backgroundColor: "white", width: "100%", height: "32px", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px", fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} placeholder="Enter product description" name="offer_description" onChange={handleChange} />
                                    </Box>
                                    {formData.offer_type!=="bogo"&&formData.offer_type!=="loyalty offer"&&<Box sx={{ width: "50%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                        <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Minimum Spent<span style={{ color: "red", marginLeft: "5px" }}>*</span></Typography>
                                        <InputBase value={formData.min_spent} sx={{ backgroundColor: "white", width: "100%", height: "32px", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px", fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} placeholder="Enter minimum spent amount" name="min_spent" onChange={handleChange} />
                                    </Box>}
                                    <Box sx={{ width: "50%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                        <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Total Quantity<span style={{ color: "red", marginLeft: "5px" }}>*</span></Typography>
                                        <InputBase value={formData.total_quantity} sx={{ backgroundColor: "white", width: "100%", height: "32px", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px", fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} placeholder="Enter total quantity" name="total_quantity" onChange={handleChange} />
                                    </Box>
                                </Box>
                                <Box sx={{ width: "100%", display: "flex", flexDirection: "row", gap: "10px" }}>
                                    <Box sx={{ width: "33.33%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                        <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Available Quantity</Typography>
                                        <InputBase value={formData.available_quantity} sx={{ backgroundColor: "white", width: "100%", height: "32px", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px", fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} placeholder="Enter available quantity" name="available_quantity" onChange={handleChange} />
                                    </Box>
                                    <Box sx={{ width: "33.33%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                        <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Availability<span style={{ color: "red", marginLeft: "5px" }}>*</span></Typography>
                                        <Dropdown value={formData.is_active} onChange={(e) => handleChange(e)} options={availability} optionLabel="name" name="is_active"
                                            placeholder="Select availability" className="w-full md:w-14rem" checkmark={true} highlightOnSelect={false} />
                                    </Box>
                                    <Box sx={{ width: "33.33%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                        <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Inventory List</Typography>
                                        <MultiSelect 
                                                value={formData.inventory_list} 
                                                onChange={handleChange} 
                                                options={filteredInventory} 
                                                optionValue="value"
                                                optionLabel="name" 
                                                optionDisabled="disabled"
                                                name="inventory_list"
                                                placeholder="Select Inventory List" 
                                                className="w-full md:w-14rem" 
                                                checkmark={true} 
                                                highlightOnSelect={false} 
                                            />
                                    </Box>
                                </Box>
                                <Box sx={{ width: "100%", display: "flex", flexDirection: "row", gap: "10px" }}>
                                    <Box sx={{ width: "50%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                        <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Set start date<span style={{ color: "red", marginLeft: "5px" }}>*</span></Typography>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker
                                                value={formData.start_date}
                                                onChange={(date) => handleChange(date, "start_date")}
                                                className="pan-datepicker background"
                                                renderInput={(params) => <TextField {...params} />}
                                                name="start_date"
                                                sx={{
                                                    "&.pan-datepicker .MuiInputBase-root.MuiOutlinedInput-root": {
                                                        height: '32px',
                                                        padding: '0 8px',
                                                        border: "none",
                                                        width: "100%",
                                                        backgroundColor: "#FFF",
                                                        zIndex: 2
                                                    },
                                                    "&.MuiPaper-root-MuiPickersPopper-paper": {
                                                        backgroundColor: "#FFF"
                                                    },
                                                    "& .MuiPaper-root": {
                                                        backgroundColor: "#FFF",
                                                        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
                                                        borderRadius: '8px',
                                                    },

                                                }}
                                            />
                                        </LocalizationProvider>
                                    </Box>
                                    <Box sx={{ width: "50%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                        <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Set end date<span style={{ color: "red", marginLeft: "5px" }}>*</span></Typography>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker
                                                value={formData.end_date}
                                                onChange={(date) => handleChange(date, "end_date")}
                                                className="pan-datepicker background"
                                                renderInput={(params) => <TextField {...params} />}
                                                name="end_date"
                                                sx={{
                                                    "&.pan-datepicker .MuiInputBase-root.MuiOutlinedInput-root": {
                                                        height: '32px',
                                                        padding: '0 8px',
                                                        border: "none",
                                                        width: "100%",
                                                        backgroundColor: "#FFF",
                                                        zIndex: 2
                                                    },
                                                    "&.MuiPaper-root-MuiPickersPopper-paper": {
                                                        backgroundColor: "#FFF"
                                                    },
                                                    "& .MuiPaper-root": {
                                                        backgroundColor: "#FFF",
                                                        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
                                                        borderRadius: '8px',
                                                    },

                                                }}
                                            />
                                        </LocalizationProvider>
                                    </Box>
                                </Box>



                            </Box>

                        </Box>
                        <Box sx={{ backgroundColor: "#EEEEEE", display: "flex", alignItems: "center", position: "absolute", bottom: 0, display: "flex", justifyContent: "flex-end", width: "100%" }}>
                            <Box sx={{ padding: "12px 24px", display: "flex", gap: "20px" }}>
                                <Button variant="outlined" sx={{ textTransform: "none", color: "black", backgroundColor: "white", height: "32px", width: "67px" }} onClick={handleClose}> cancel</Button>
                                <Button variant="contained" sx={{ textTransform: "none", height: "32px", width: "67px" }} onClick={() => edit ? handleUpdateOffer(offerDetails.offer_id) : handleSaveOffer()} > {edit ? loading ? <CircularProgress size="25px" sx={{ color: "white" }} /> : "Update" : loading ? <CircularProgress size="25px" sx={{ color: "white" }} /> : "Save"}</Button>
                            </Box>
                        </Box>
                    </Box>
                </Modal>
            </Box>
        </Box>
    )
}